// Enum for expense categories to avoid hard-coded strings
export const ExpenseCategoryEnum = {
    Misc: 'Misc',
    Other: 'Other',
    Travel: 'Travel',
    Supplemental: 'Supplemental',
};
